import { render, staticRenderFns } from "./ReplyNewConditionsParentingTime.vue?vue&type=template&id=1153eed7"
import script from "./ReplyNewConditionsParentingTime.vue?vue&type=script&lang=ts"
export * from "./ReplyNewConditionsParentingTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports